export default "__VITE_ASSET__BacppCuw__"